import {LineItemField, transform as codeFieldTransform} from './code-field-type';

export interface LineItem {
    id: string;
    fields: LineItemField[];
}

export interface AccountingCode {
    enabled: boolean;
    id: string;
    lineItems: LineItem[] | null;
    name: string;
}

export interface Code {
    id: string;
    name: string;
    enabled: boolean;
    company: string;
    accountId: string;
    lineItemId: string;
    worktags: LineItemField[];
}

export const transform = {
    fromApi: (data: AccountingCode) => {
        const code: Code = {
            id: data.id,
            name: data.name,
            enabled: data.enabled,
            company: '',
            accountId: '',
            lineItemId: '',
            worktags: [],
        };

        if (Array.isArray(data.lineItems) && data.lineItems.length > 0) {
            code.lineItemId = data.lineItems[0].id;
            data.lineItems[0].fields.forEach((field: LineItemField) => {
                code.worktags.push(codeFieldTransform.fromApi(field));
            });
        }

        return code;
    },

    toApi: (data: Code) => {
        const code: AccountingCode = {
            id: data.id,
            name: data.name,
            enabled: data.enabled,
            lineItems: [
                {
                    id: data.lineItemId,
                    fields: [],
                },
            ],
        };

        data.worktags.forEach(worktag => code.lineItems[0].fields.push(codeFieldTransform.toApi(worktag)));
        return code;
    },
};
